import React, { useRef, useState, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import { slideInDown } from 'react-animations'
import { fontSizeResponsive, mediaQ } from '../../../theme/mixins'
// import BackButton from '../../shared/BackButton'
import Modal from 'react-modal'

// import menuTexts from '../../../constants/staticTexts'
import DropdownSubscription from './subSettings/DropdownSubscription'
import DropdownPrivacy from './subSettings/DropdownPrivacy.jsx'
import DropdownAppVersion from './subSettings/DropdownAppVersion.jsx'
import DropdownModal from './subSettings/DropdownModal.jsx'
import DeleteAccountDropdownModal from './subSettings/DeleteAccountDropdownModal.jsx'
import AcceptNewsletterModal from './subSettings/AcceptNewsletterModal.jsx'

import DropdownRules from './subSettings/DropdownRules.jsx'
import DropdownFaq from './subSettings/DropdownFaq.jsx'
import DropdownContact from './subSettings/DropdownContact.jsx'
// import backButtonIcon from '../../../assets/navBar/backButtonIcon.png'
import { useOutsideAlerter } from '../../../../utils/index'
import closeIcon from '../../../../assets/mainScreen/closeIcon.png'
import closeWhiteIcon from '../../../../assets/mainScreen/closeIconWhite.png'
import { getUserData } from '../../../../Api/backendApi'
// import {
//   BrowserView,
//   MobileView,
//   isBrowser,
//   isMobile,
// } from 'react-device-detect'

import platform from 'platform'

// import { getuserOperatingSystem } from '../../../utils/getUserSystem'

// import { APP_VERSION } from '../../../routes/routeURL/index'

const fadeInAnimation = keyframes`${slideInDown}`
export const DropdownMenuHeader = styled.div`
  position: absolute;
  display: none;
  z-index: 0;
  display: flex;
  width: 100%;
  /* height: 5.2vh; */
  padding: 10px 0;
  align-items: center;

  ${mediaQ('mobileAll', 'display: flex; position:fixed;')}
`
const DropdownMenuHeaderItem = styled.div`
  background: ${(props) => (props.icon ? `url(${props.icon})` : null)};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: ${(props) => (props.icon ? '20px' : 'unset')};
  height: ${(props) => (props.icon ? '20px' : 'unset')};
  order: ${(props) => (props.icon ? '1' : '2')};
  margin: 0 2%;

  font-family: 'Asap Condensed';
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: normal;
  color: #ffffff;
`

const settingsAnimation = keyframes`

  from{
    backdrop-filter: blur(4px);
    top:0;
    opacity:0;
    background-color: rgba(255, 255, 255, 0.98);
  }
  to{
    opacity: 1;
    backdrop-filter: blur(4px);
    background-color: rgba(255, 255, 255, 0.98);
    top: 17vh;
  }
`

const DropdownMenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5% 0;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.98);
  position: absolute;

  z-index: 12;

  backdrop-filter: blur(4px);
  top: ${(props) => (props.isVisible ? '17vh' : '0')};
  width: 100%;
  /* border-top: 1px solid rgba(0, 0, 0, 0.16); */
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.08);
  animation: 0.7s ${settingsAnimation};
  align-items: baseline;
  ${mediaQ('mobileAll', 'animation-duration:0.5s;')}
  /* transition: all 0.3s ease-in-out; */

  ${mediaQ(
    'mobileAll',
    'top: 0vh;height:100%;z-index:3; position:fixed;    display: flex;flex-direction: column;'
  )}
`
const MenuItem = styled.div`
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(24)};
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  letter-spacing: normal;
  line-height: unset;
  color: #212121;
  padding: 15px 0 0 0;
  cursor: pointer;
  position: relative;
  z-index: -1;

  display: flex;
  justify-content: space-between;
  width: 30%;
  margin-left: auto;
  &:hover {
    font-weight: bold;
    color: #fe0d9f;
  }

  ${mediaQ('mobileAll', 'width:100%;font-size:20px;padding: 15px 0 0 2%;')}
`
const MenuItemName = styled.div`
  color: ${(props) => (props.color ? props.color : 'inherit')};
  position: relative;
  /* z-index: -1; */
`
const MenuListItemsContainer = styled.div`
  width: 81%;
  border-right: rgba(254, 13, 159, 0.1) 2px solid;
  padding: 0 0 10% 0;
  z-index: 1;

  ${mediaQ('mobileAll', 'width: 100%;')}
`
const MenuDescriptionItemsContainer = styled.div`
  width: 50%;
  padding: 0 15% 0 4%;
  align-self: end;
  ${mediaQ('mobileAll', 'width: 100%; text-align: center; padding:0')}
`
export const CloseButton = styled.button`
  position: ${(props) => (props.position ? props.position : 'absolute')};
  top: ${(props) => (props.top ? props.top : '9%')};
  right: ${(props) => (props.right ? props.right : '9%')};
  background: ${(props) =>
    props.whiteCloseIcon ? `url(${closeWhiteIcon})` : `url(${closeIcon})`};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: ${(props) => (props.whiteCloseIcon ? '20px' : '30px')};

  height: ${(props) => (props.whiteCloseIcon ? '20px' : '30px')};
  border: none;
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : 'unset')};
  z-index: 4;

  ${mediaQ('mobileAll', 'top: 3%;')}
`
export const MenuDescriptionText = styled.div`
  font-family: ${(props) => (props.header ? 'Asap Condensed' : 'Open Sans')};
  ${(props) => (props.header ? fontSizeResponsive(32) : fontSizeResponsive(18))}
  font-weight: ${(props) => (props.header ? 'bold' : 'normal')};
  font-stretch: ${(props) => (props.header ? 'condensed' : 'normal')};
  margin-bottom: 1%;
  margin-top: ${(props) => (props.mt ? props.mt : 'unset')};
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${(props) =>
    props.headerColor
      ? '#fe0d9f'
      : props.headerColorAlt
      ? '#9e0dfe'
      : '#212121'};
`
const MailLink = styled.button`
  justify-content: space-between;
  width: 30%;
  padding: 0;
  margin-left: auto;
  display: block;
  text-decoration: none;
  font-family: 'Asap Condensed';
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  border: none;
  background: none;
  text-align: left;
  /* margin-top: 15px; */

  ${fontSizeResponsive(24)}
  ${mediaQ('desktopAll', 'margin-top: 15px;')}
  ${mediaQ('mobileAll', 'width:100%;font-size:20px;padding: 15px 0 0 2%;')}

  &:hover {
    font-weight: bold;
  }
`

const fillDropdownMenu = (e) => {}

Modal.setAppElement('#root')

const DropdownMenu = ({
  isVisible,
  closeMenu,
  changeLocation,
  logout,
  userMail,
  user,
  trainingDays,
  allWatchedVids,
  activeSubscriptionEndTime,
  userId,
  updateUserSubLocalChange,
  isUserNewsletterSub,
}) => {
  const wrapperRef = useRef(null)
  const [modalIsOpen, setIsOpen] = React.useState(false)
  const [deleteModalIsOpen, setDeleteModalIsOpen] = React.useState(false)

  const [isNewsletterModalOpen, setNewsletterModalOpen] = React.useState(false)

  //  Get user data
  const [userData, setUserData] = useState({})

  const getUser = async () => {
    const result = await getUserData()

    setUserData(result)
  }

  useEffect(() => {
    ;(async () => {
      getUser()
    })()
  }, [])

  const openNewsletterModal = () => {
    setNewsletterModalOpen(true)
  }
  const closeNewsletterModal = () => {
    setNewsletterModalOpen(false)
  }

  useOutsideAlerter(wrapperRef, useState, closeMenu, modalIsOpen)

  const [message, setMessage] = useState('')

  const deleteUser = () => {}

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false)
  }

  const openDeleteModal = () => {
    setDeleteModalIsOpen(true)
  }

  const openModal = () => {
    setIsOpen(true)
  }
  const closeModal = () => {
    setIsOpen(false)
  }
  const afterOpenModal = (e) => {}

  // const findLastWatchedVid = () => {
  //   let maxDate = 'brak'

  //   if (
  //     allWatchedVids !== undefined &&
  //     allWatchedVids.length !== undefined &&
  //     allWatchedVids !== null
  //   ) {
  //     maxDate = new Date(
  //       Math.max(...allWatchedVids.map((e) => new Date(e.watched_datetime)))
  //     )
  //   }

  //   return maxDate
  // }

  // const findLastLockedVid = () => {
  //   let maxDate = 'brak'
  //   if (allWatchedVids != undefined && allWatchedVids.length != undefined) {
  //     maxDate = new Date(
  //       Math.max(...allWatchedVids.map((e) => new Date(e.locked_datetime)))
  //     )
  //   }

  //   return maxDate
  // }

  // const composeUserDetails = (userId) => {
  //   let sortedTrainingDays = trainingDays.sort()

  // const user = {
  //   email: userMail,
  //   id: userId,
  //   platform: 'Web',
  //   systemFamily: platform.os.family,
  //   systemVersion: platform.os.version,
  //   systemArchitecture: platform.os.architecture,
  //   browserName: platform.name,
  //   browserVersion: platform.version,
  //   clientWidth: window.innerWidth,
  //   clientHeight: window.innerHeight,
  //   trainingDays: sortedTrainingDays,
  //   lastWatchedVid: findLastWatchedVid(),
  //   lastLockedVid: findLastLockedVid(),
  // }

  //   const issueRequestEmailSubject = 'WEB - Problem techniczny'
  //   let issueRequestEmailBody =
  //     '\r\n' +
  //     '\r\n' +
  //     'Twoje dane diagnostyczne: ' +
  //     '\r\n' +
  //     `UserId: ${userId}` +
  //     '\r\n' +
  //     'Platforma: Web' +
  //     '\r\n' +
  //     'Przeglądarka: ' +
  //     `${platform.name} ${platform.version}` +
  //     '\r\n' +
  //     'Aktualna rozdzielczość ekranu: ' +
  //     `${window.innerWidth} x ${window.innerHeight}` +
  //     '\r\n' +
  //     'Dni treningowe: ' +
  //     `${sortedTrainingDays}` +
  //     '\r\n' +
  //     'Data ostatnio obejrzanego treningu miazga: ' +
  //     `${findLastWatchedVid()}` +
  //     '\r\n' +
  //     'Data zablokowanego treningu: ' +
  //     `${findLastLockedVid()}`

  //   // issueRequestEmailBody = encodeURIComponent(issueRequestEmailBody)
  //   const userData = { formattedData: issueRequestEmailBody, objectData: user }
  //   return userData
  // }

  // const userData = user == undefined ? null : composeUserDetails(user.id)
  return (
    <DropdownMenuContainer
      ref={wrapperRef}
      closeMenu={closeMenu}
      isVisible={isVisible}
    >
      <CloseButton onClick={closeMenu} />
      <MenuListItemsContainer>
        <MailLink onClick={openModal}>
          <MenuItemName color="#ec0101">Zgłoś błąd</MenuItemName>
        </MailLink>
        {modalIsOpen && (
          <DropdownModal
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
            // user={userData}
            // userId={user != undefined ? user.id : null}
            afterOpenModal={afterOpenModal}
          />
        )}
        <MailLink onClick={openDeleteModal}>
          <MenuItemName color="#ec0101">Usuń konto</MenuItemName>
        </MailLink>

        <MenuItem onClick={openNewsletterModal}>
          {userData && userData.is_newsletter_subscriber
            ? 'Usuń z newslettera'
            : 'Zapisz do newslettera'}
        </MenuItem>
        <AcceptNewsletterModal
          modalIsOpen={isNewsletterModalOpen}
          closeModal={closeNewsletterModal}
          isUserNewsletterSub={userData && userData.is_newsletter_subscriber}
          updateUserSubLocalChange={updateUserSubLocalChange}
        />

        <DeleteAccountDropdownModal
          modalIsOpen={deleteModalIsOpen}
          closeModal={closeDeleteModal}
          deleteUser={deleteUser}
          logout={logout}
        />
        <MenuItem
          onClick={() =>
            window.open(
              'https://fitmatkawariatka.pl/regulamin-aplikacji-miazga-nowy/',
              '_blank'
            )
          }
        >
          <MenuItemName>Regulamin</MenuItemName>
        </MenuItem>
        <MenuItem
          onClick={() =>
            window.open(
              'https://fitmatkawariatka.pl/polityka-prywatnosci-aplikacja-miazga/',
              '_blank'
            )
          }
        >
          Polityka prywatności
        </MenuItem>
        <MenuItem
          onClick={() =>
            window.open(
              'https://fitmatkawariatka.pl/aplikacja-miazga-faq/',
              '_blank'
            )
          }
        >
          FAQ
        </MenuItem>
        <MenuItem
          onClick={() =>
            window.open(
              'https://fitmatkawariatka.pl/kontakt-aplikacja-miazga/',
              '_blank'
            )
          }
        >
          Kontakt
        </MenuItem>
        <MenuItem onClick={() => setMessage('appversion')}>
          Wersja aplikacji
        </MenuItem>
        <MenuItem onClick={() => setMessage('subscription')}>
          Moja subskrypcja
        </MenuItem>
        <MenuItem onClick={logout}>Wyloguj się</MenuItem>
      </MenuListItemsContainer>
      <MenuDescriptionItemsContainer>
        {message == 'subscription' && <DropdownSubscription />}

        {message == 'privacy' && <DropdownPrivacy />}
        {message == 'appversion' && <DropdownAppVersion />}
        {message == 'rules' && <DropdownRules />}
        {message == 'FAQ' && <DropdownFaq />}
        {message == 'contact' && <DropdownContact />}
      </MenuDescriptionItemsContainer>
    </DropdownMenuContainer>
  )
}

export default DropdownMenu
